// src/components/BookFinder/BookList.js
import React from 'react';

// Make sure `onBookSelect` is listed here
const BookList = ({ books, onBookSelect }) => { 
  if (!books || books.length === 0) {
    return null;
  }

  return (
    <div className="book-list-view">
      {books.map((book, index) => (
        // Make sure the onClick is exactly like this
        <div key={book.key} className="book-list-item" onClick={() => onBookSelect(book)}>
          <div className="book-rank">#{index + 1}</div>
          <div className="book-list-cover">
            {book.cover_id ? (
              <img 
                src={`https://covers.openlibrary.org/b/id/${book.cover_id}-M.jpg`} 
                alt={`${book.title} cover`}
              />
            ) : (
              <div className="no-cover-list">No Cover</div>
            )}
          </div>
          <div className="book-list-details">
            <h3>{book.title}</h3>
            <p>by {book.authors ? book.authors.join(', ') : 'Unknown'}</p>
            <p className="book-list-meta">First Published: {book.publish_year || 'N/A'}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default BookList;